import { Box, Button, Drawer, IconButton, Tooltip, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions'
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents'
import { DateTime } from 'luxon'
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

const OPIPServiceHeadWiseReport = (props) => {
    const [states, setStates] = useState({
        serviceHeadWiseData: [],
        FilterOpen: false,
        total_amount: 0,
        page: 0,
        pageSize: 10,
        isLoader: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
        module_type: [
            ...(props?.fromIPReport ? ["IP"] : ["OP"]),
            "RADIOLOGY", "LAB",
            ...(localGetItem("Investigation_List")
                ? JSON.parse(localGetItem("Investigation_List"))
                : []),
        ],
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const history = useHistory()

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }


    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS

    useEffect(() => {
        const filterDetails = history?.location?.state;
        const hasFilter = filterDetails?.module_type?.length > 0;

        const today = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd');

        const defaults = {
            fromDate: today,
            toDate: today,
            dateIndex: 1,
            module_type: [
                ...(props?.fromIPReport ? ["IP"] : ["OP"]),
                "RADIOLOGY",
                "LAB",
                ...(localGetItem("Investigation_List")
                    ? JSON.parse(localGetItem("Investigation_List"))
                    : []),
            ],
        };
        const update = {...(hasFilter ? filterDetails : defaults)};

        // update state
        setStates(prev => ({
            ...prev,
            isLoader: true,
            ...update,
        }));

        getOPIPServiceHeadReport(update);
    }, [JSON.stringify(history?.location?.state)])

    const getOPIPServiceHeadReport = (paramsData) => {
        try {
            const { fromDate, toDate, module_type } = paramsData || states;
            setStates((prev) => ({
                ...prev,
                isLoader: true
            }))
            let params = `?from_date=${fromDate}&to_date=${toDate}&module_type=${module_type}${props?.fromIPReport ? "&from_ip=true" : ""}`
            RestAPIService.getAll(Serviceurls.OP_IP_SERVICE_HEAD_WISE_REPORT + params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({
                            ...prev,
                            serviceHeadWiseData: response?.data?.data ?? [],
                            total_amount: response?.data?.overall_total_amt ?? 0,
                            isLoader: false
                        }))
                    }
                }).catch(error => {
                    setStates((prev) => ({ ...prev, isLoader: false }))
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({ ...prev, isLoader: false }))
            errorMessage(error.message)
        }
    }

    const getOPIPServiceHeadReportPrint = () => {
        try {
            let params = `?from_date=${states.fromDate}&to_date=${states.toDate}&module_type=${states.module_type}&export_type=pdf${props?.fromIPReport ? "&from_ip=true" : ""}`
            RestAPIService.getAll(Serviceurls.OP_IP_SERVICE_HEAD_WISE_REPORT + params)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(states.fromDate) },
            { label: "To Date", value: formatDate(states.toDate) },
        ]
        return (
            <Box><CommonGridToolBarWithFilterText FilterTextArray={TextArray} /></Box>

        )
    }

    const renderTable = () => {
        states.serviceHeadWiseData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.05,
                renderCell: (params) => {
                    return (
                        <Box>{params?.row?.sno}</Box>
                    )
                }
            },
            {
                field: 'service_head_name', headerName: 'Service Head', flex: 0.45,
                renderCell: (params) => {
                    let serviceHeadName = params?.row?.service_head_name
                    return (
                        <Box component={'div'}>
                            {serviceHeadName ? serviceHeadName?.length > 60 ?
                                <Tooltip placement='top' title={serviceHeadName}><Typography>{serviceHeadName?.slice(0, 60) + '...'}</Typography></Tooltip> :
                                <Typography>{serviceHeadName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'no_of_services', headerName: 'No of Services', flex: 0.2,
                renderCell: (params) => {
                    let no_service = params?.row?.no_of_services
                    return (
                        <Box component={'div'}>
                            {no_service ? no_service?.length > 60 ?
                                <Tooltip placement='top' title={no_service}><Typography>{no_service?.slice(0, 60) + '...'}</Typography></Tooltip> :
                                <Typography>{no_service}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'total_amt', headerName: 'Amount', flex: 0.2,
                renderCell: (params) => {
                    let amount = params?.row?.total_amt
                    return (
                        <Box component={'div'}>
                            {amount ? amount?.length > 60 ?
                                <Tooltip placement='top' title={amount}><Typography>{amount?.slice(0, 60) + '...'}</Typography></Tooltip> :
                                <Typography>{amount}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => {
                    let data = params?.row
                    return (
                        <Box component={'div'}>
                            <Tooltip placement='top' title='Service Name List'>
                                <IconButton
                                    onClick={() => {
                                        history?.push({
                                            pathname: '/ServiceHeadWiseReportView', state: {
                                                fromIPReport: props?.fromIPReport ?? false,
                                                service_head_id: data?.service_head_id,
                                                fromDate: states.fromDate,
                                                toDate: states.toDate,
                                                serviceData: data?.data,
                                                dateIndex: states.dateIndex,
                                                module_type: states.module_type,
                                            }
                                        })
                                    }}
                                ><FormatListBulletedIcon color='primary' /></IconButton>
                            </Tooltip>
                        </Box>
                    )
                }
            },
        ]
        return (
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={states.serviceHeadWiseData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={states.page}
                    pageSize={states.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setStates((prev) => ({ ...prev, page: newPage })) }}
                    onPageSizeChange={(newPageSize) => setStates((prev) => ({ ...prev, pageSize: newPageSize }))}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={states.isLoader}
                />
            </Box>
        )
    }

    const closeFilter = () => {
        setStates((prev) => ({ ...prev, FilterOpen: false }))
    }

    const FilterDate = (from, to, index) => {
        setStates((prev) => ({
            ...prev,
            fromDate: from,
            toDate: to,
            dateIndex: index
        }))
    }

    const handleCheckboxChange = (field, value) => {
        setStates((prev) => {
            const currentValues = prev[field];
            const updatedValues = currentValues.includes(value)
                ? currentValues.filter((v) => v !== value)  // Remove if already selected
                : [...currentValues, value];                // Add if not selected
            return { ...prev, [field]: updatedValues };
        });
    };

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{("Filter")}</Typography>
                    <Button onClick={() => { setStates((prev) => ({ ...prev, FilterOpen: false })) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={states.fromDate}
                            ToDate={states.toDate}
                            DateIndex={states.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={true} />
                    </Box>
                    {/* Module Type */}
                    <Box component={"div"}>
                        <Typography fontWeight={500} fontSize={"1vw"} marginLeft={'1vw'}>Module Type</Typography>
                        <Box className="eMed_CheckBox_Group">
                            {[...(props?.fromIPReport ? ["IP"] : ["OP"]), 'RADIOLOGY', 'LAB', ...JSON.parse(localGetItem("Investigation_List") || "[]")].map((type) => (
                                <FormControlLabel
                                    key={type}
                                    control={
                                        <Checkbox
                                            checked={states.module_type.includes(type)}
                                            onChange={() => handleCheckboxChange('module_type', type)}
                                        />
                                    }
                                    label={type.toUpperCase()}
                                />
                            ))}
                        </Box>
                    </Box>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button variant='outlined' size="small" sx={{ mr: '1rem' }}
                        onClick={() => {
                            setStates((prev) => ({
                                ...prev,
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                module_type: [
                                    ...(props?.fromIPReport ? ["IP"] : ["OP"]),
                                    "RADIOLOGY", "LAB",
                                    ...(localGetItem("Investigation_List")
                                        ? JSON.parse(localGetItem("Investigation_List"))
                                        : []),
                                ],
                            }))
                        }}
                        id="eMed_Config_btn">{("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            if (states.module_type?.length === 0) {
                                errorMessage('Select Atleast One Module Type')
                            } else {
                                setStates((prev) => ({ ...prev, FilterOpen: false }))
                                getOPIPServiceHeadReport()
                            }
                        }}
                        id="eMed_Config_btn">{("Search")}</Button>
                </Box>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '80dvh', backgroundColor: Colors.Background }}>
            <Box component={"div"} className='eMed_Top_Container'>
                <Box component={"div"} className='eMed_Cards_Container'>
                    {AmountsCard(("Total Amount"), states.total_amount)}
                </Box>
                <Box component={"div"} className='eMed_Action_Container'>
                    <Box component={"div"} className='eMed_Filter_Icon_div'>
                        <Button className='eMed_usrconf_btn' onClick={() => { setStates((prev) => ({ ...prev, FilterOpen: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Box>
                    <Button className='eMed_usrconf_btn'
                        onClick={() => getOPIPServiceHeadReportPrint()}
                    >
                        <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                </Box>
            </Box>
            {renderTable()}
            <Drawer
                anchor={'right'}
                open={states.FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default OPIPServiceHeadWiseReport